import React from "react";
import { connect } from "react-redux";
import { Filter, utils, field } from "@mc/mc-legacy";
import * as actions from "../actions/OverviewActions";
import { ThunkDispatch } from "redux-thunk";

const fields = [
  {
    name: "dateRange",
    label: "Datum vyřizování",
    component: field.DateRangeField,
  },
];


type Props = { itemList: { allIds: number[]; fetched: boolean; filter: any }; dispatch: ThunkDispatch<any, any, any> };

/**
 * Filtr přehledu
 */
class PrehledFilter extends React.Component<Props> {
  componentDidMount() {
    this.filter({
      dateRange: null,
    });
  }

  filter = (values) => {
    this.props.dispatch(actions.filter(values));
  };

  render() {
    const { itemList } = this.props;
    return (
      <div className={"mt-5"}>
        <Filter fields={fields} values={itemList.filter} onChange={this.filter} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, actions.OVERVIEW),
  };
}

export default connect(mapStateToProps)(PrehledFilter);
